import React, { Component } from 'react';
import { Card, Row, Col, Table, Button, Input, ButtonGroup, Alert as Alert2 } from "reactstrap";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, filterHelper } from "../helpers";
import { TextFilter, FilterSet, ActiveToggleFilter, Pager } from "../components";

const emptyProductBundle = {
  bundleProductId: null,
  productId: null,
  productCount: null,
}

const getProducts = () => api.fetch('Reference/Products').then(response => {
  return {
    productList: _.filter(response.data, l => { return l.isBundleProduct === false }),
    bundleProductList: _.filter(response.data, r => { return r.isBundleProduct === true})
  };
}).catch(x => console.error(x));

export default class ProductBundle extends Component {
  static displayName = ProductBundle.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      bundleItemList: [],
      productList: [],
      bundleProductList:[], //has only bundle products
      selectedProductList: [],
      editBundleProduct: null,
      filters: [],
      pagedList: null,
      sortColumn: "Id",
      sortAscending: true,

    }
    this.addProductBundle = this.addProductBundle.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);

  }

  componentDidMount() {
    Promise.all([getProducts()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => {
        this.onChangeFilter({
          filterName: "activeOnly",
          value: true,
          filteredDisplay: "Active Only"
        });
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.changeCount !== this.props.changeCount) {
      this.refreshList();
    }
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/BundleProductItems", payload)
      .then(response => {
        if (response && response.data) {
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: response.data.dataSource,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
            editBundleProduct: null,
            message: null,
            messageColor: null,
            isMessageVisible: false,
          });
        }
    })
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters });
    this.refreshList(null, null, filters, 1);
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  addProductBundle() {
    this.setState({
      editBundleProduct: emptyProductBundle
    })
  }

  onInputChange(e, fieldName) {
    this.setState({
      editBundleProduct: { ...this.state.editBundleProduct, [fieldName]: e.target.value }
    })
  }

  onSelectChange(selection, fieldName) {
    this.setState({
      editBundleProduct: { ...this.state.editBundleProduct, [fieldName]: selection.target.value }
    })
  }

  onCancel() {
    this.setState({
      editBundleProduct: null
    });
  }

  onEdit(bundleItemId, bundleIndex) {
    let list = this.state.pagedList.list.slice();
    let item = _.find(list[bundleIndex].bundleItemList, p => {
      return p.id === bundleItemId
    })

    this.setState({
      editBundleProduct: item
    })
  }

  isFormValid() {
    let warnings = [];
    if (this.state.editBundleProduct.bundleProductId === null) {
      warnings.push("Please select a bundle");
    }
    if (this.state.editBundleProduct.productCount === null) {
      warnings.push("Please enter a product count");
    }
    if (this.state.editBundleProduct.productCount && this.state.editBundleProduct.productCount < 1) {
      warnings.push("Please enter a product count that is greater than 0");
    }

    if (!this.state.editBundleProduct.productId === null) {
      warnings.push("Please select a product");
    }
    this.setState({ message: (warnings.length ? warnings.join(", ") : null), messageColor: "danger", isMessageVisible: true });
    return warnings.length === 0;
  }

  onSave() {
    if (!this.isFormValid()) return;
    let bundle = Object.assign({}, this.state.editBundleProduct);
    let payload = {
      BundleProductId: parseInt(bundle.bundleProductId, 10),
      ProductCount: parseInt(bundle.productCount, 10),
      ProductId: parseInt(bundle.productId, 10)
    }

    if (bundle.id) {
      payload.Id = bundle.id
    }

    api.post("Admin/SaveBundleProductItem", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(`Bundle was created.`)
          this.refreshList();
          this.props.refreshAll();
        } else {
          Alert.error("An error occurred. Bundle cannot be created at this time.")
        }
      }).catch(error => Alert.error("There was an error creating the Bundle."));
  }

  onDelete(bundleItemId) {
    if (!window.confirm(`Are you sure you'd like to delete Bundle Item?`)) return;

    api.delete(`Admin/DeleteBundleProductItem/${bundleItemId}`)
      .then(response => {
        if (response.data.success) {
          Alert.success(`Bundle Item was deleted.`);
          this.refreshList();
        } else {
          Alert.error("An error occurred. Bundle Item cannot be deleted at this time.");
        }
      }).catch(error => {
        Alert.error(`There was an error deleting Bundle Item.`)
      });
  }

  onRevive(bundleItemId) {
    api.post("Admin/ReviveBundleProductItem", bundleItemId)
      .then(response => {
        if (response.data.success) {
          Alert.success(`Bundle Item  was revived.`);
          this.refreshList();
        } else {
          Alert.error(`An error occurred. Bundle Item  cannot be revived at this time.`);
        }
      }).catch(error => Alert.error(`There was an error reviving the Bundle Item.`));
  }


  render() {
    let editBundleProduct = this.state.editBundleProduct;
    return (
      <div>
        <Row>
          <Col className="blueText"><h5>Product Bundles</h5></Col>
          <Col className="mr-3">
            {this.state.editBundleProduct ? null : (
              <Button size="sm" color="success" className="float-right" onClick={this.addProductBundle}>Add New Product Bundle</Button>
            )}
          </Col>
        </Row>

        {this.state.message ? (
          <Alert2 color={this.state.messageColor} toggle={() => this.onDismiss()}>{this.state.message}</Alert2>
        ) : null}

        {this.state.editBundleProduct ? (
          <Card className="p-2">
            <Row>
              <Col>Product Bundle:
                <select name="bundleProductId" id="bundleProductId" className="form-control" onChange={(e) => this.onSelectChange(e, "bundleProductId")}>
                  <option value="">Select product</option>
                  {this.state.bundleProductList.length > 0 && (
                    this.state.bundleProductList.map(bundle => (
                      <option key={bundle.id} value={bundle.id} selected={this.state.editBundleProduct.bundleProductId === bundle.id}>{bundle.name}</option>
                    ))
                  )}
                </select>
              </Col>
              <Col>Products:
                <select name="productId" id="productId" className="form-control" onChange={(e) => this.onSelectChange(e, "productId")}>
                  <option selected value="">Select product</option>
                  {this.state.productList.length > 0 && (
                    this.state.productList.map(p => (
                      <option key={p.id} value={p.id} selected={this.state.editBundleProduct.productId === p.id}>{p.name}</option>
                    ))
                  )}
                </select>
              </Col>
              <Col>Product Quantity: <Input type="number" name="productCount" id="productCount" onChange={(e) => this.onInputChange(e, "productCount")} value={editBundleProduct.productCount || ''} /></Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ButtonGroup className="float-right">
                  <Button size="sm" color="secondary" onClick={this.onCancel}>Cancel</Button>
                  <Button size="sm" className="cbdmdPrimary" onClick={() => this.onSave()}>Save</Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>
        ) : null}

        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor">
              <Col xs="3">
                <TextFilter
                  filterName="bundleProductName"
                  displayName="Bundle Product Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
              <TextFilter
                filterName="productName"
                displayName="Product Name"
                descriptionPrefix="contains"
                onChangeCallback={this.onChangeFilter}
              />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="activeOnly"
                  displayName="Active Only"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "activeOnly",
                    this.state.filters
                  )}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Product Bundle</th>
                  <th>Product Name</th>
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map((item, index) => (
                    <tr key={index}>
                      <td>{item.bundleProductName}</td>
                      <React.Fragment>
                      {item.bundleItemList ? (
                        item.bundleItemList.map(b => (
                          <tr key={b.id}>
                            <td style={{ width: "500px" }}>Product: {b.productName}</td>
                            <td style={{ width: "100px" }}>Quantity: {b.productCount}</td>
                            <td>
                              <ButtonGroup>
                                {b.deactivatedAt ? (
                                  <Button size="sm" className="cbdmdInfo" onClick={() => this.onRevive(b.id)} disabled={this.state.editBundleProduct !== null}>Revive</Button>
                                ) : (
                                    <React.Fragment>
                                      <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onEdit(b.id, index)} disabled={this.state.editBundleProduct !== null} title="Edit">
                                        <FontAwesomeIcon
                                          icon="edit"
                                          className="ml-1 mt-0 mb-0 mr-1 pointer"
                                          title="Edit"
                                        />
                                      </Button>
                                      <Button size="sm" className="cbdmdDanger buttonGroupSpacing" onClick={() => this.onDelete(b.id)} disabled={this.state.editBundleProduct !== null} title="Delete">
                                        <FontAwesomeIcon
                                          icon="trash-alt"
                                          className="ml-1 mt-0 mb-0 mr-1 pointer "
                                          title="Delete"
                                        />
                                      </Button>
                                    </React.Fragment>
                                  )}
                              </ButtonGroup>
                            </td>

                          </tr>
                        ))
                        ) : null}
                      </React.Fragment>
                    </tr>
                  ))) :
                  <tr>
                    <td>
                      No Records available
                    </td>
                  </tr>
                }
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />

          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ProductBundle.js